import React from "react";
import { Grid, TextField, MenuItem } from "@mui/material";
import { Relais } from "../../models/signalUsers/relais.ts";
import { Signal } from "../../models/signal.ts";
import { getSignalLabelFromList } from "../../utils/signalUtils.ts";

interface Props {
  data: Relais;
  setIsValid: (isValid: boolean) => void;
  onChange: (relais: Relais) => void;
  signalOptions: Signal[];
}

const EditRelaisForm: React.FC<Props> = ({ data, setIsValid, onChange, signalOptions }) => {
  const handleChange = (relais: Relais) => {
    onChange(relais);
    if (relais.high_signal.id === relais.low_signal.id || relais.high_signal.id === "" || relais.low_signal.id === "") {
      setIsValid(false);
    } else {
      setIsValid(true);
    }
  };
  return (
    <Grid container spacing={2} sx={{ mt: 2 }}>
      <Grid size={{ xs: 12, sm: 6 }}>
        <TextField
          select fullWidth label="Pin 1"
          value={data.high_signal.id}
          error={data.high_signal.id === "" || data.high_signal.id === data.low_signal.id}
          onChange={(e) => {
            const selected = signalOptions.find(s => s.id === e.target.value);
            if (selected) handleChange({ ...data, high_signal: selected });
          }}
        >
          {signalOptions.map(opt => (
            <MenuItem key={opt.id} value={opt.id}>{getSignalLabelFromList(opt.id, signalOptions)}</MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }}>
        <TextField
          select fullWidth label="Pin 2"
          value={data.low_signal.id}
          error={data.low_signal.id === "" || data.high_signal.id === data.low_signal.id}
          onChange={(e) => {
            const selected = signalOptions.find(s => s.id === e.target.value);
            if (selected) handleChange({ ...data, low_signal: selected });
          }}
        >
          {signalOptions.map(opt => (
            <MenuItem key={opt.id} value={opt.id}>{getSignalLabelFromList(opt.id, signalOptions)}</MenuItem>
          ))}
        </TextField>
      </Grid>
    </Grid>
  );
};

export default EditRelaisForm;
